import { RedirectCommand, ResolveFn, Router } from "@angular/router";
import {
  AccountSelectionLocalStorageKeys,
  AccountSelectionQueryParams,
  OrganizationAccountGroupService,
} from "@front/m19-services";
import { inject } from "@angular/core";
import { map } from "rxjs";

export const accountSelectionResolver: ResolveFn<boolean> = (route, state) => {
  const accountGroupService = inject(OrganizationAccountGroupService);
  const router = inject(Router);
  const params = route.queryParams;

  const accountIdFromParams = params[AccountSelectionQueryParams.accountId];
  const marketplaceFromParams = params[AccountSelectionQueryParams.marketplace];
  const orgIdFromParams = params[AccountSelectionQueryParams.orgId];

  if (accountIdFromParams && marketplaceFromParams && orgIdFromParams) return true;

  return accountGroupService.allOrganizationAccountGroups$.pipe(
    map((allOrganizations) => {
      if (!allOrganizations) return false;

      allOrganizations = allOrganizations.filter((o) => o.accountGroups && o.accountGroups.length > 0);
      const allGroups = allOrganizations.flatMap((o) => o.accountGroups);

      if (allGroups.length == 0) return false;

      const storedAccount = +(localStorage.getItem(AccountSelectionLocalStorageKeys.accountGroup) ?? 0);
      const accountGroup = allGroups.find((a) => a.id == storedAccount) ?? allGroups[0];
      let selectedAccountMarketplace = accountGroup.getAccountMarketplaces()[0];

      const storedMarketplace = localStorage.getItem(AccountSelectionLocalStorageKeys.marketplace);
      if (storedMarketplace) {
        const selectedMarketplace = accountGroup
          .getAccountMarketplaces()
          .find((am) => am.marketplace == storedMarketplace);
        if (selectedMarketplace) {
          selectedAccountMarketplace = selectedMarketplace;
        }
      }

      return new RedirectCommand(
        router.createUrlTree([state.url], {
          queryParamsHandling: "merge",
          queryParams: {
            [AccountSelectionQueryParams.accountId]: selectedAccountMarketplace.accountId,
            [AccountSelectionQueryParams.marketplace]: selectedAccountMarketplace.marketplace,
            [AccountSelectionQueryParams.orgId]: selectedAccountMarketplace.resourceOrganizationId,
          },
        }),
      );
    }),
  );
};
